import { readStorage, writeStorage } from './storage'

export type ThemePreference = 'light' | 'dark' | 'system'

export const THEME_STORAGE_KEY = 'theme'
export const DARK_CLASS = 'app-dark'

export function readThemePreference(): ThemePreference {
  const value = readStorage(THEME_STORAGE_KEY)
  return value === 'light' || value === 'dark' ? value : 'system'
}

export function resolveDark(pref: ThemePreference, systemPrefersDark: boolean): boolean {
  return pref === 'dark' || (pref === 'system' && systemPrefersDark)
}

/** Применяет тему к <html> и запоминает выбор. Используется переключателем в настройках. */
export function applyThemePreference(pref: ThemePreference): void {
  writeStorage(THEME_STORAGE_KEY, pref)
  const systemDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  document.documentElement.classList.toggle(DARK_CLASS, resolveDark(pref, systemDark))
}

/**
 * При выборе «как в системе» тема меняется вместе с системной (телефон переключился на
 * ночной режим), без перезагрузки. Вызывается один раз при запуске приложения.
 */
export function followSystemTheme(): void {
  const media = window.matchMedia?.('(prefers-color-scheme: dark)')
  media?.addEventListener('change', (event) => {
    if (readThemePreference() === 'system') {
      document.documentElement.classList.toggle(DARK_CLASS, event.matches)
    }
  })
}
